import styled from 'styled-components'

export const CommentListWrap = styled.ul`
    list-style: none;
    width: 100%;
`